document.addEventListener("DOMContentLoaded", function(event) {
    let menu = document.querySelectorAll('.btn-event-menu')
    let anchors = document.querySelectorAll('.HeaderMenu-itemLink')
    let message = document.querySelector('#container-message')
    
    if(document.querySelector('.new_window')) {
      let menu_blank = document.querySelector('.new_window').querySelector('.link_anchor')
      menu_blank.addEventListener('click',(e) => {
        e.preventDefault();
    
        window.open(menu_blank.parentNode.dataset.link,'_blank');
      })
    }
  
    message.addEventListener('mouseover',() =>{
      let overligth = document.querySelector('.overlight-global');
      let messageContainer = document.querySelector('.modal-chat');
      overligth.classList.add('active')
      messageContainer.classList.add('active')
    });
    message.addEventListener('mouseout',() =>{
      let overligth = document.querySelector('.overlight-global');
      let messageContainer = document.querySelector('.modal-chat');
      overligth.classList.remove('active')
      messageContainer.classList.remove('active')
    });
  
    // Función para mostrar el submenú
    function showSubMenu(element) {
      element.classList.add('menu-event-active')
  
      let height = element.querySelector('.sub-menu').scrollHeight;
      let height_padding = height + 10;
      element.querySelector('.sub-menu').style.cssText = `height: ${height_padding}px;`
    }
  
    // Función para ocultar el submenú
    function hideSubMenu(element) {
      element.classList.remove('menu-event-active')
  
      element.querySelector('.sub-menu').style.cssText = `height: 0px;`
    }
  
    menu.forEach(function(element) {
      element.addEventListener('mouseover',() => showSubMenu(element));
      element.addEventListener('mouseout',() => hideSubMenu(element));
    });
  
    anchors.forEach(function(element) {
      element.addEventListener('click',(e) => {
        e.preventDefault();
        window.location.href = element.getAttribute('href');
      });
    });
  
    let menu_mobile = document.querySelectorAll('.menu-first a .link_anchor')
  
    menu_mobile.forEach(function(element) {
      element.addEventListener('click',(e) => {
        e.preventDefault();
        window.location.href = element.parentNode.getAttribute('href');
      });
    });
  
    let sub_menu_mobile = document.querySelectorAll('.menu-first .HeaderDropdown-menu-mobile .childLink ')
  
    sub_menu_mobile.forEach(function(element) {
      element.addEventListener('click',(e) => {
        e.preventDefault();
        window.location.href = element.getAttribute('href');
      });
    });
  
    let svg_mobile = document.querySelectorAll('.menu-first a .container-svg')
    let sub_svg_mobile = document.querySelectorAll('.menu-first .HeaderDropdown-menu-mobile .container-arrow')
  
    svg_mobile.forEach(function(element) {
      element.addEventListener('click',(e) => {
        e.preventDefault();
  
        svg_mobile.forEach(function(menu) {
          if (menu !== element) {
            menu.parentNode.classList.remove('active')
  
            if (menu.parentNode.nextElementSibling) {
              menu.parentNode.nextElementSibling.classList.remove('active')
            }
          }
        });
  
        sub_svg_mobile.forEach(function(menu) {
          if (menu !== element) {
            menu.parentNode.nextElementSibling.classList.remove('active')
            menu.parentNode.classList.remove('active')
          }
        });
  
        element.parentNode.nextElementSibling.classList.toggle('active')
        element.parentNode.classList.toggle('active')
      });
    });
  
  
    sub_svg_mobile.forEach(function(element) {
      element.addEventListener('click',(e) => {
        e.preventDefault();
  
        sub_svg_mobile.forEach(function(menu) {
          if (menu !== element) {
            menu.parentNode.nextElementSibling.classList.remove('active')
            menu.parentNode.classList.remove('active')
          }
        });
  
        /* svg_mobile.forEach(function(sub_menu) {
          if (sub_menu.parentNode !== open_menu) {
            sub_menu.parentNode.classList.remove('active')
            if(sub_menu.parentNode.nextElementSibling) {
              sub_menu.parentNode.nextElementSibling.classList.remove('active')
            }
            console.log(sub_menu.parentNode.nextElementSibling, '1', open_sub_menu, '2', open_menu)
          }
        }); */
  
        element.parentNode.nextElementSibling.classList.toggle('active')
        element.parentNode.classList.toggle('active')
      });
    });
  
    const annoumentbar = () =>{
      let swipper = document.querySelector('.swiper.js-slide-promo-bar')
      let shop_by = document.querySelector('.is-middle .js-header-menu-list li:first-child a')
      let spacing = shop_by.getBoundingClientRect().left - 30;
  
      if (window.innerWidth > 1380) {
        swipper.style.cssText = 'padding-left: '+spacing+'px; margin: 0px;'
      } else {
        swipper.style.cssText = 'padding-left: initial; margin: auto;'
      }
    }
  
    annoumentbar();
  
    window.addEventListener('resize', annoumentbar);
  
    /* COUNTDOWN */
    function updateTimer(element) {
      let date_countdown;
      if (element.querySelector('.date-countdown') !== null) {
          date_countdown = element.querySelector('.date-countdown').textContent.trim().split('/');
      }
      let time_countdown;
      if (element.querySelector('.time-countdown') !== null) {
          time_countdown = element.querySelector('.time-countdown').textContent.trim() ?? '00:00';
      }

      let title_date_countdown = '';
      if (element.querySelector('.title-date-countdown') !== null) {
          title_date_countdown = element.querySelector('.title-date-countdown').textContent;
      }
      const timerBottomElement = element.querySelector('#timer_bottom');

      let future;
      if (date_countdown !== undefined) {
          future = new Date(`${date_countdown[2]}-${date_countdown[0]}-${date_countdown[1]}T${time_countdown}:00`);
      }

      let now = new Date();
      let estTime = new Date(now.toLocaleString("en-US", { timeZone: "America/New_York" }));
      let diff = future - estTime;

      if (diff < 0 && timerBottomElement) {
          timerBottomElement.innerHTML = `<div class="container-time">${title_date_countdown ? title_date_countdown : ''} 00:00:00</div>`;
          return;
      }

      let days = Math.floor(diff / (1000 * 60 * 60 * 24));
      let hours = Math.floor(diff / (1000 * 60 * 60));
      let mins = Math.floor(diff / (1000 * 60));
      let secs = Math.floor(diff / 1000);

      let d = days;
      let h = hours - days * 24;
      let m = mins - hours * 60;
      let s = secs - mins * 60;

      if (String(d).length < 2) {
          d = '0' + d;
      }

      if (String(h).length < 2) {
          h = '0' + h;
      }

      if (String(m).length < 2) {
          m = '0' + m;
      }

      if (String(s).length < 2) {
          s = '0' + s;
      }

      h = d * 24 + Number(h);

      if (timerBottomElement) {
          timerBottomElement.innerHTML =
              `<div class="container-time">${title_date_countdown ? title_date_countdown : ''}` + h + ':</div>' +
              '<div class="container-time">' + m + ':</div>' +
              '<div class="container-time">' + s + '</div>';
      }
    }

    const countdownElement = document.querySelectorAll('.content-countdown');

    countdownElement.forEach(element => {
      setInterval(function () {
          updateTimer(element);
      }, 1000);
    });
  
    // funcion para mostrar el sub sub menu
  
    /* let subMenu = document.querySelectorAll('.sub-menu-item')
  
    subMenu.forEach(function(element) {
      element.addEventListener('mouseover',() => {
        element.querySelector('.sub-sub-menu').classList.add('active')
      });
  
      element.addEventListener('mouseout',() => {
        element.querySelector('.sub-sub-menu').classList.remove('active')
      });
    }); */
  });

document.addEventListener("DOMContentLoaded", () => {
  const amburgerMenu = document.querySelector('.js-header-menu-toggle');

  amburgerMenu.addEventListener('click', function() {
    this.classList.toggle('active');
  });
});